<section class="courier-return-schedule">
  <h4 class="fw-bold mb-2">{{ heading() }}</h4>

  <div class="courier-return-schedule__instructions wysiwyg" [innerHTML]="safeInstructions()"></div>

  @if (needsAddress()) {
    <div class="row mt-4">
      <div class="col-6 col-lg-5 col-xl-4">
        <div class="form-group form-group-xl">
          <label class="d-block">{{ 'common.postNumber' | translate }}</label>

          <ui-input-loader-wrap [loading]="postNumberBusy()">
            <input class="form-control"
                   type="tel"
                   [placeholder]="('common.postNumberPlaceholder_' + countryCode()) | translate"
                   [inputMask]="'postNumber'"
                   [inputMaskArgs]="{ countryCode: countryCode() }"
                   [ngModel]="postNumberInput()"
                   (ngModelChange)="onPostNumberChange($event)"/>
          </ui-input-loader-wrap>
        </div>
      </div>

      <div class="col-6 col-lg-7 col-xl-8">
        <div class="form-group form-group-xl">
          <label class="d-block">{{ 'common.postalArea' | translate }}</label>

          <input class="form-control"
                 type="text"
                 readonly
                 disabled
                 [placeholder]="'common.postalArea' | translate"
                 [value]="store.pickupCity()"/>
        </div>
      </div>

      @if (isPostNumberUnavailable()) {
        <div class="col-12">
          <div class="text-danger mb-3">
            {{ 'orderProcess.delivery.deliveryForms.notAvailable' | translate }}
          </div>
        </div>
      }
    </div>

    <div class="form-group form-group-xl">
      <label class="d-block">{{ 'common.delivery.deliveryAddress' | translate }}</label>

      <input class="form-control"
             type="text"
             [placeholder]="'orderProcess.delivery.deliveryForms.deliveryAddressPlaceholder' | translate"
             [disabled]="!isPostNumberResolved()"
             [ngModel]="store.pickupAddress()"
             (ngModelChange)="onAddressChange($event)"/>
    </div>
  }

  <div class="row mt-2">
    <div class="col-6 col-lg-4">
      <div class="form-group form-group-xl">
        <label>{{ 'orderProcess.returnPackaging.courierReturn.dateLabel' | translate }}</label>

        <ui-delivery-datepicker
          [calendar]="calendar()"
          [disabled]="isScheduleDisabled()"
          [minDate]="earliestDate()"
          [placement]="'bottom-left'"
          [ngModel]="store.date()"
          (ngModelChange)="onDateChange($event)"
          (onMonthNavigate)="onMonthNavigate($event)"
        ></ui-delivery-datepicker>
      </div>
    </div>

    <div class="col-6 col-lg-4">
      <div class="form-group form-group-xl">
        <label>{{ 'orderProcess.returnPackaging.timeLabel' | translate }}</label>

        <div class="dropdown-container dropdown-item-slim">
          <ui-dropdown
            [items]="timeOptions()"
            [placeholder]="'common.timePlaceholder' | translate"
            [disabled]="isScheduleDisabled()"
            [ngModel]="store.time()"
            [placement]="'bottom'"
            (changeItem)="onTimeChange($event)"
          ></ui-dropdown>
        </div>
      </div>
    </div>

    @if (store.price() !== null) {
      <div class="col-12 col-lg-4">
        <div class="form-group form-group-xl">
          <label>{{ 'orderProcess.returnPackaging.courierReturn.priceLabel' | translate }}</label>
          <div class="courier-return-schedule__price">{{ store.price() | currencyFormat: currency() }}</div>
        </div>
      </div>
    }
  </div>

  @if (isCalendarFailed()) {
    <div class="text-danger">
      {{ 'notifications.error.common.unexpectedError.message' | translate }}
    </div>
  }
</section>
